import React, { useEffect, useRef, useState } from "react";
import {
  Box,
  Button,
  Card,
  CardActionArea,
  CardMedia,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";
import "./card-flip-game.css";
import { CSSTransition } from "react-transition-group";
import { emoji } from "../utils/DataSource";
import cardBackgroundImage from "../static/images/card-background.jpg";
import { AppSingleton } from "../services/user_config";

const getRandomPairs = (numberOfCards) => {
  const roots = emoji.animals
    .sort(() => 0.5 - Math.random())
    .slice(0, numberOfCards / 2)
    .map((el) => ({
      // uid: `card-${index}`,
      title: el,
      isHide: true,
      isResolved: false,
    }));
  return [...roots, ...roots]
    .sort(() => 0.5 - Math.random())
    .map((el, index) => ({ ...el, uid: `${index}` }));
};

const CardFlipGame = () => {
  const numberOfCards = 8; // MARK: Must be even numbers !!
  const [contents, setContents] = useState(getRandomPairs(numberOfCards));
  const [isBlockUserInteraction, setIsBlockUserInteraction] = useState(false);
  const animationInterval = 1000;
  // const appSingleton = new AppSingleton();

  const [cardSize, setCardSize] = useState({});

  useEffect(() => {
    // setCardSize({
    //   width: `${((appSingleton.windowSize.height / 3.0) * 3.0) / 4.0}px`,
    //   height: `${appSingleton.windowSize.height / 3.0}px`,
    // });
    setCardSize({
      width: "160px",
      height: `${(160 * 4) / 3}px`,
    });
  }, []);

  return (
    <>
      <Box sx={{ mt: 8 }}>
        <Grid container justifyContent="center">
          {contents.map((content) => {
            return (
              // <Grid item xs={3} className="card-container" key={content.uid}>
              <Card
                sx={{
                  // position: "relative",
                  m: 1,
                  width: cardSize.width,
                  height: cardSize.height,
                  backgroundColor: content.isResolved ? "#C8E6C9" : "#FFFFFF",
                }}
              >
                <Button
                  className="card-button"
                  disabled={isBlockUserInteraction || content.isResolved}
                  sx={{ width: "100%", height: "100%" }}
                  onClick={() => {
                    setIsBlockUserInteraction(true);
                    let updatedContents = contents.map((el) =>
                      el === content ? { ...el, isHide: !el.isHide } : { ...el }
                    );
                    setContents(updatedContents);

                    if (
                      updatedContents.filter(
                        (el) => !el.isResolved && !el.isHide
                      ).length >= 2
                    ) {
                      // MARK: Visualize computation after 1000 ms
                      setTimeout(() => {
                        const willBeResolvedContents = updatedContents.filter(
                          (el) => !el.isResolved && !el.isHide
                        );
                        if (willBeResolvedContents.length >= 2) {
                          if (
                            new Set(
                              willBeResolvedContents.map((el) => el.title)
                            ).size === 1
                          ) {
                            // MARK: Resolve cards if the title are the same
                            updatedContents.forEach((el) => {
                              willBeResolvedContents.forEach((_el) => {
                                if (el === _el) {
                                  el.isResolved = true;
                                }
                              });
                            });
                          } else {
                            // MARK: Flip off 2 opended matches
                            updatedContents.forEach((el) => {
                              willBeResolvedContents.forEach((_el) => {
                                if (el === _el) {
                                  el.isHide = true;
                                }
                              });
                            });
                          }
                        }
                        setContents(updatedContents);
                        setIsBlockUserInteraction(false);
                      }, animationInterval);
                    } else {
                      setIsBlockUserInteraction(false);
                    }
                  }}
                >
                  <CSSTransition
                    in={content.isHide}
                    timeout={animationInterval}
                    classNames="front-face-transition"
                  >
                    <Box className="card-front" sx={{ overflow: "hidden" }}>
                      <img
                        src={cardBackgroundImage}
                        loading="lazy"
                        style={{ objectFit: "cover" }}
                      />
                    </Box>
                  </CSSTransition>
                  <CSSTransition
                    in={!content.isHide}
                    timeout={animationInterval}
                    classNames="back-face-transition"
                  >
                    <div className="card-back">
                      <Typography sx={{ fontSize: "96px" }}>
                        {content.title}
                      </Typography>
                    </div>
                  </CSSTransition>
                </Button>
              </Card>
              // </Grid>
            );
          })}
        </Grid>
      </Box>
    </>
  );
};

export { CardFlipGame };
